import React, { useState, useEffect, useMemo } from "react";
import { Row, Col, Pagination } from "react-bootstrap";
import BTable from "react-bootstrap/Table";
import {
  useTable,
  useSortBy,
  usePagination,
  useGlobalFilter,
} from "react-table";
import { FaArrowUp, FaArrowDown } from "react-icons/fa";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { toast } from "react-toastify";
import "./CommonTable.css";
import { useNavigate } from "react-router-dom";

const CommonTable = ({
  columns,
  data,
  pagecount,
  setPageno,
  pageno = 1,
  showPagination = true,
  color = "#000",
  onUserNameClick,
}) => {
  const [pagenumber, setPagenumber] = useState(1);
  const navigate = useNavigate();

  const tableData = useMemo(() => data, [data]);
  const tableColumns = useMemo(() => columns, [columns]);
  console.log("tableData", data);
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    rows,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns: tableColumns,
      data: tableData,
      initialState: { pageIndex: pageno ? pageno - 1 : 0, pageSize: 10 },
      manualPagination: !!pagecount,
      pageCount: pagecount ? pagecount.last_page : undefined,
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  const isManualPagination = !!pagecount;
  const displayRows = isManualPagination ? rows : page;

  const getUserPayload = (row) => {
    if (!row?.original) return null;
    const rowData = row.original;
    const candidate =
      rowData?.user || rowData?.created_by_user || rowData?.user_details || rowData;
    const candidateId =
      candidate?.id ||
      candidate?._id ||
      rowData?.user_id ||
      rowData?.id ||
      rowData?.user?.id ||
      rowData?.user_id;
    if (!candidateId) return null;
    if (candidate?.id || candidate?._id) {
      return candidate;
    }
    return {
      ...candidate,
      id: candidateId,
    };
  };

  const handleUserNameNavigation = (row, header) => {
    if (!row) return;
    if (onUserNameClick) {
      onUserNameClick(row.original, { page: pageno || 1 });
      return;
    }
    const payload = getUserPayload(row);
    if (!payload) return;

    const isBuyerName = String(header || "").trim() === "Buyer Name";
    const id = isBuyerName
      ? payload?.buyer_id || payload?.user_id || payload?.seller_id || payload?.id
      : payload?.user_id || payload?.seller_id || payload?.id;

    navigate("/users-view", {
      state: {
        data: payload,
        page: pageno || 1,
        id,
      },
    });
  };

  useEffect(() => {
    const newPage = pageIndex + 1;
    setPagenumber(newPage);
    if (!pagecount && setPageno) {
      setPageno(newPage);
    }
  }, [pageIndex]);

  return (
    <div className="common-table-wrapper">
      <BTable
        size="sm"
        responsive
        {...getTableProps()}
        className="common-table"
      >
        <thead>
          {headerGroups.map((headerGroup, ind) => (
            <tr
              {...headerGroup.getHeaderGroupProps()}
              key={ind}
              style={{ border: "9px solid red" }}
            >
              {headerGroup.headers.map((column, indx) => (
                <th
                  {...column.getHeaderProps(column.getSortByToggleProps())}
                  key={indx}
                //   style={{ border: "none" }}
                >
                  <div className="d-flex align-items-center justify-content-between">
                    <span>{column.render("Header")}</span>
                    <span className="sort-icon">
                      {column.isSorted ? (
                        column.isSortedDesc ? (
                          <FaArrowDown />
                        ) : (
                          <FaArrowUp />
                        )
                      ) : (
                        ""
                      )}
                    </span>
                  </div>
                </th>
              ))}
            </tr>
          ))}
        </thead>
        {!data || data.length === 0 ? (
          <tbody {...getTableBodyProps()}>
            <tr>
              <td colSpan={columns.length} className="no-data-cell">
                No Record Found
              </td>
            </tr>
          </tbody>
        ) : (
          <tbody {...getTableBodyProps()}>
            {displayRows.map((row, i) => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()} key={i}>
                  {row.cells.map((cell, ind) => {
                    const cellProps = cell.getCellProps();
                    const isUserNameCell =
                      String(cell.column?.Header || "").trim() === "User Name" ||
                      String(cell.column?.Header || "").trim() === "Seller Name" ||
                      String(cell.column?.Header || "").trim() === "Buyer Name";
                    const combinedClassName = [
                      cellProps.className,
                      isUserNameCell ? "user-name-cell" : null,
                    ]
                      .filter(Boolean)
                      .join(" ");
                    return (
                      <td
                        style={{
                          border: "none",
                          color: color,
                          cursor: isUserNameCell ? "pointer" : "default",
                          borderBottom: "1px solid #D5D5D5",
                        }}
                        {...cellProps}
                        onClick={
                          isUserNameCell
                            ? () => handleUserNameNavigation(cell.row, cell.column?.Header)
                            : undefined
                        }
                        className={combinedClassName || undefined}
                        key={ind}
                      >
                        {cell.render("Cell")}
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        )}
      </BTable>

      {showPagination && pagecount && (
        <Row className="justify-content-end table-pagination px-2">
          <Col xs="auto">
            <div className="d-flex align-items-center gap-2">
              <span className="pagination-text">Page</span>
              <Pagination className="mb-0">
                <button
                  className="pagination-btn"
                  onClick={() => {
                    setPageno(
                      pagecount?.current_page === 1
                        ? pagecount?.current_page
                        : pagecount?.current_page - 1
                    );
                  }}
                  disabled={pagecount?.current_page === 1}
                >
                  <KeyboardArrowLeftIcon />
                </button>
                <input
                  type="number"
                  className="pagination-input"
                  value={pagecount?.current_page}
                  readOnly={true}
                  disabled={true}
                  onChange={(e) => {
                    setPageno(
                      e.target.value > pagecount.last_page
                        ? pagecount?.last_page
                        : e.target.value
                    );
                  }}
                  min="1"
                  max={pagecount?.last_page}
                />
                <button
                  className="pagination-btn"
                  onClick={() => {
                    setPageno(
                      pagecount?.current_page >= pagecount?.last_page
                        ? pagecount?.last_page
                        : pagecount?.current_page + 1
                    );
                    if (pagecount?.current_page >= pagecount?.last_page)
                      toast.info("No More Pages Available...");
                  }}
                  disabled={pagecount?.current_page >= pagecount?.last_page}
                >
                  <KeyboardArrowRightIcon />
                </button>
              </Pagination>
              <span className="pagination-text">of {pagecount?.last_page}</span>
            </div>
          </Col>
        </Row>
      )}

      {showPagination && !pagecount && (
        <Row className="justify-content-end table-pagination px-2">
          <Col xs="auto">
            <div className="d-flex align-items-center gap-2">
              <span className="pagination-text">Page</span>
              <Pagination className="mb-0">
                <Pagination.Prev
                  onClick={() => {
                    previousPage();
                    if (canPreviousPage && setPageno) {
                      setPageno(pageno - 1);
                    }
                  }}
                  disabled={!canPreviousPage}
                />
                <input
                  type="number"
                  className="pagination-input"
                  value={pagenumber}
                  disabled={true}
                  readOnly={true}
                  onChange={(e) => {
                    if (!Number(e.target.value)) {
                      setPagenumber(e.target.value);
                      return;
                    }
                    if (e.target.value > pageCount) {
                      gotoPage(pageCount - 1);
                      setPagenumber(pageCount);
                      return;
                    }
                    const page = e.target.value
                      ? Number(e.target.value) - 1
                      : 0;
                    gotoPage(page);
                    setPagenumber(e.target.value);
                  }}
                  min="1"
                  max={pageCount}
                />
                <Pagination.Next
                  onClick={() => {
                    nextPage();
                    if (canNextPage && setPageno) {
                      setPageno(pageno + 1);
                    }
                  }}
                  disabled={!canNextPage}
                />
              </Pagination>
              <span className="pagination-text">of {pageCount}</span>
            </div>
          </Col>
        </Row>
      )}
    </div>
  );
};

export default CommonTable;
